module.exports = __webpack_public_path__ + "img/f71f447d7a113a591f0b2bd8db4b47da.png";